import { connect } from 'react-redux';
import AudienceSegment from './AudienceSegment';

import './AudienceSegment.css';

import {
  selectId,
  selectName,
  selectFilters,
  selectOpen,
  selectLoading,
  selectError
} from '../../reducers/audience-segment-reducer';
import { selectConfig, selectSegments } from '../../reducers/filters-reducer';
import {
  closeAudienceSegmentWindow,
  saveAudienceSegment,
  updateFilters,
  updateFilterOptions
} from '../../actions/audience-segment-actions';

// import {
//   updateFilters,
//   updateFilterOptions
// } from '../../actions/filters-actions';

import {
  defaultStateForMapStateToProps,
  defaultActionsForMapDispatchToProps
} from '../../utils/redux';

const defaultState = {
  id: selectId,
  name: selectName,
  filters: selectFilters,
  isOpen: selectOpen,
  config: selectConfig,
  loading: selectLoading,
  error: selectError,
  segments: selectSegments
};

const defaultActions = {
  onClose: closeAudienceSegmentWindow,
  onSave: saveAudienceSegment,
  onUpdateFilterOptions: updateFilterOptions,
  updateFilters
};

const mapStateToProps = defaultStateForMapStateToProps(defaultState);
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudienceSegment);
